import { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { Chip } from '@digdir/designsystemet-react';
import type { SurveyModule } from '../../../domain/surveys/survey-list';
import classes from '../SurveysPage.module.css';

export type ModuleFilterValue = SurveyModule | 'all';

type ModuleFilterProps = {
  modules: SurveyModule[];
  value: ModuleFilterValue;
  onChange: (value: ModuleFilterValue) => void;
};

export const ModuleFilter = ({ modules, value, onChange }: ModuleFilterProps) => {
  const { t } = useTranslation();
  const name = useId();
  const options: { value: ModuleFilterValue; label: string }[] = [
    { value: 'all', label: t('surveys.page.filterAll') },
    ...modules.map((module) => ({ value: module, label: t(`surveys.page.modules.${module}`) })),
  ];

  return (
    <div role="radiogroup" aria-label={t('surveys.page.filterLabel')} className={classes.filters}>
      {options.map((option) => (
        <Chip.Radio
          key={option.value}
          name={name}
          data-size="sm"
          checked={value === option.value}
          onChange={() => onChange(option.value)}
        >
          {option.label}
        </Chip.Radio>
      ))}
    </div>
  );
};
